<template>
  <v-alert
    icon="mdi-delete"
    type="error"
    variant="outlined"
  >
    <span class="font-weight-bold text-black">{{ $t('settings.delete-account.title') }}<br /></span>

    <div class="text-black">
      <p>
        {{ $t('settings.delete-account.subtitle') }}
      </p>
      <p v-if="!canDeleteAccount">
        <b>{{ $t('settings.delete-account.body-texts.0') }}: </b
        >{{
          $t('settings.delete-account.body-texts.1', { date: formatDate(endDate, 'DATE_LONG') })
        }}
      </p>
    </div>

    <div class="d-flex justify-end pb-8">
      <DialogComponent
        v-if="canDeleteAccount"
        action="delete"
        :title="$t('settings.delete-account.dialog.title')"
        :content="$t('settings.delete-account.dialog.content', { readablePlatformName })"
        :submit="() => deleteAccount()"
        color="error"
      >
        <v-btn
          color="error"
          variant="text"
          :disabled="!canDeleteAccount"
          @click="deleteAccount"
        >
          <v-icon class="mr-2"> mdi-delete </v-icon>
          {{ $t('buttons.delete-account.cta') }}
        </v-btn>
      </DialogComponent>
    </div>
  </v-alert>
</template>

<script>
import DialogComponent from '@/components/forms/Dialog.vue'
import brandingMixin from '@/mixins/branding'

import SubscriptionState from '../enums/SubscriptionState'

export default {
  components: { DialogComponent },
  mixins: [brandingMixin],
  props: {
    subscriptionState: {
      type: String,
      default: '',
    },
    endDate: {
      type: Date,
      default: null,
    },
  },
  computed: {
    canDeleteAccount() {
      return this.subscriptionState === SubscriptionState.INACTIVE
    },
  },
  methods: {
    deleteAccount() {
      // TODO send delete prompt to bottimmo-service
    },
  },
}
</script>
